import "../styles/globals.css";
import "simplebar/src/simplebar.css";
import type { AppProps } from "next/app";

import React from "react";
import Dynamic from "next/dynamic";
import AppLoading from "../sections/loading/app";

const DynamicLayout = Dynamic(() => import("../layout/dynamicLayout"), {
  ssr: false,
  loading: () => <AppLoading />,
});

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <React.StrictMode>
      <DynamicLayout component={<Component {...pageProps} />}></DynamicLayout>
    </React.StrictMode>
  );
}

export default MyApp;
